/**
 * The breadcrumbs UI component.
 */

import { IcoChevronRight } from '@components/icons';

export interface Crumb {
  href?: string;
  text: string;
}

export function Divider() {
  return <IcoChevronRight class="w-4 h-4 text-gray-700 mx-2" />;
}

export function Breadcrumbs({ crumbs }: { crumbs: Array<Crumb | undefined> }) {
  const crumbClass =
    'inline-block text-inherit whitespace-nowrap overflow-hidden max-w-40 text-ellipsis';

  return (
    <div class="flex items-center gap-2 text-sm">
      {crumbs.map((crumb) => {
        if (!crumb) {
          return;
        }
        if (crumb.href) {
          return (
            <>
              <a href={crumb.href} class={crumbClass} key={crumb.href}>
                {crumb.text}
              </a>
              <Divider />
            </>
          );
        }
        return (
          <span key={crumb.text} class={crumbClass}>
            {crumb.text}
          </span>
        );
      })}
    </div>
  );
}
